module.exports = __webpack_public_path__ + "img/attached-file.1175e6f4.svg";